//@flow
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import React from 'react';
import Grid from '@mui/material/Grid2';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import LinkIcon from "../../../assets/images/icons/general/linkIcon";
import { EXHIBITOR_PROFILE } from "../../../locales/components/namespaces";
import { showNoValueIfDisabled } from "./catalog";
import { FormControl, FormHelperText, Tooltip } from "@mui/material";
import { ErrorMessage } from "formik";
import Typography from "@mui/material/Typography";

const CatalogSocial = ({ formik, inputVariant, disabled }) => {
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	return (
		<Grid container spacing={1.5}>
			<Grid size={12}>
				<ListItem sx={{ p: 0 }}>
					<ListItemIcon sx={{ minWidth: '2rem' }}>
						<LinkIcon/>
					</ListItemIcon>
					<ListItemText>
						<Typography
							variant="bodyMedium"
							component={"div"}
							sx={{
								color: '#5E666B',
								fontWeight: 'bold',
								fontSize: '15px'
							}}
						>
							CONTACTS
						</Typography>
					</ListItemText>
				</ListItem>
				<Divider sx={{ mb: '2rem', border: '1px solid #5E666B' }}/>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<FormControl
						variant="standard"
						color={'error'}
						fullWidth
						error={
							formik.touched['social.email'] &&
							Boolean(formik.errors['social.email'])
						}
					>
						<TextField
							disabled={disabled}
							variant={inputVariant}
							label="E-mail"
							required
							type={'email'}
							size={"small"}
							name={'social.email'}
							value={showNoValueIfDisabled(formik.values.social.email, disabled)}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							fullWidth
							maxLength={250}
						/>
						<FormHelperText sx={{ color: '#d32f2f' }}>
							<ErrorMessage name={'social.email'}/>
						</FormHelperText>
					</FormControl>
				</Box>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<FormControl
						variant="standard"
						color={'error'}
						fullWidth
						error={
							formik.touched['social.website'] &&
							Boolean(formik.errors['social.website'])
						}
					>
						<TextField
							disabled={disabled}
							fullWidth
							size={"small"}
							variant={inputVariant}
							label="Website"
							name={'social.website'}
							value={showNoValueIfDisabled(formik.values.social.website, disabled)}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							maxLength={250}
						/>
						<FormHelperText sx={{ color: '#d32f2f' }}>
							<ErrorMessage name={'social.website'}/>
						</FormHelperText>
					</FormControl>
				</Box>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<FormControl
						variant="standard"
						color={'error'}
						fullWidth
						error={
							formik.touched['social.fb'] &&
							Boolean(formik.errors['social.fb'])
						}
					>
						<TextField
							disabled={disabled}
							fullWidth
							variant={inputVariant}
							label="Facebook"
							size={"small"}
							name={'social.fb'}
							value={showNoValueIfDisabled(formik.values.social.fb, disabled)}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							maxLength={250}
						/>
						<FormHelperText sx={{ color: '#d32f2f' }}>
							<ErrorMessage name={'social.fb'}/>
						</FormHelperText>
					</FormControl>
				</Box>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<FormControl
						variant="standard"
						color={'error'}
						fullWidth
						error={
							formik.touched['social.instagram'] &&
							Boolean(formik.errors['social.instagram'])
						}
					>
						<TextField
							disabled={disabled}
							fullWidth
							variant={inputVariant}
							label="Instagram"
							size={"small"}
							name={'social.instagram'}
							value={showNoValueIfDisabled(formik.values.social.instagram, disabled)}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							maxLength={250}
						/>
						<FormHelperText sx={{ color: '#d32f2f' }}>
							<ErrorMessage name={'social.instagram'}/>
						</FormHelperText>
					</FormControl>
				</Box>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<FormControl
						variant="standard"
						color={'error'}
						fullWidth
						error={
							formik.touched['social.linkedIn'] &&
							Boolean(formik.errors['social.linkedIn'])
						}
					>
						<TextField
							disabled={disabled}
							fullWidth
							size={"small"}
							variant={inputVariant}
							label="LinkedIn"
							name={'social.linkedIn'}
							value={showNoValueIfDisabled(formik.values.social.linkedIn, disabled)}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							maxLength={250}
						/>
						<FormHelperText sx={{ color: '#d32f2f' }}>
							<ErrorMessage name={'social.linkedIn'}/>
						</FormHelperText>
					</FormControl>
				</Box>
			</Grid>
		</Grid>
	)
}

export default CatalogSocial
